import React from 'react';

const MainVideo = () => {

    const video = (process.env.REACT_APP_VIDEO_PATH + 'globalis-main-video.mp4')
    const poster = (process.env.REACT_APP_VIDEO_PATH + 'globalis-main-polster.jpg')
    //const transkript = (process.env.PUBLIC_URL + '/videos/transkript.vtt')

    return (
        <video poster={poster} playsInline autoPlay={true} controls={false} aria-describedby="video-transkript"
            muted
            loop>
            <source
                src={video}
                type="video/mp4"/>
            {/*<track src={transkript} kind="subtitles" lang="de" label="Deutsch" default/>*/}
        </video>
    )
}

export default MainVideo;